import { lazyLoad } from 'utils/loadable';

import { TAXPAYER_CONTEXT_USER_TYPES } from '@dec/shared';

import auth from '../auth';

import { useAuthSession } from './authSession';

const DefaultLayout = lazyLoad(
  () => import('../../layouts/default'),
  (module) => module.DefaultLayout
);
const RouteAuth = ({ access, children }: { access?: Array<string>; children: any }) => {
  const session = useAuthSession();
  if (!session.user) {
    auth.login();
    return <></>;
  }

  // contexto de contribuyente: el titular y los delegados registrados
  const isAuthorized = TAXPAYER_CONTEXT_USER_TYPES.includes(
    session.user.context?.userProfile.userType ?? ''
  );
  if (isAuthorized) {
    return children;
  }
  return (
    <div>
      <DefaultLayout>
        <div> No Autorizado</div>
      </DefaultLayout>
    </div>
  );
};

export default RouteAuth;
